module.exports = __webpack_public_path__ + "static/media/caros-black-italic.48592fb5.woff";